<!-- <div class="preloader"> 
    <div class="lds-hourglass"></div>
</div> -->
<div class="loaderIcon">
    <img src="../../../assets/images/LoaderGif.gif" alt="Loader">
</div>